/**
 * The last thing on the page: one line and the button that starts a garden
 * (the founding visitor's says their place is waiting).
 *
 * The remodelled page (landing.V2) says "Add your first plant. Grow does the
 * rest." with "Start your free trial" and, under it, the trial's days from
 * the Grow settings; the founding visitor's version is unchanged.
 *
 * Words (en/es): landing.end.*, landing.v2.end.*.
 *
 * @module EndCta
 */

import React from 'react';
import { Button } from '@/shared/components/ui/button';
import { useTranslation } from '@/shared/hooks/useTranslation';
import type { LandingSectionProps } from '../landingTypes';

/**
 * The end button.
 *
 * @param props.facts - Whether this is a founding visitor.
 * @param props.onStart - Starts a garden.
 * @param props.v2 - Whether to say the remodelled page's words.
 */
export const EndCta: React.FC<LandingSectionProps> = ({ facts, onStart, v2 }) => {
  const { reactTranslate: t } = useTranslation();
  const founding = Boolean(facts.founding);
  return (
    <section className="px-4 py-14 text-center md:px-8 md:py-24">
      <div className="mx-auto max-w-3xl space-y-4">
        <h2 className="font-grow text-3xl font-extrabold leading-[1.08] tracking-tight [text-wrap:balance] md:text-[2.6rem]">{founding ? t('landing.end.founding.title') : t(v2 ? 'landing.v2.end.title' : 'landing.end.title')}</h2>
        <Button size="lg" className="h-12 px-8 text-base" onClick={onStart}>{founding ? t('landing.end.founding.cta') : t(v2 ? 'landing.v2.end.cta' : 'landing.end.cta')}</Button>
        {v2 && !founding && <p className="text-sm text-muted-foreground">{t('landing.v2.end.note', { days: facts.trialDays })}</p>}
      </div>
    </section>
  );
};
